module.exports = __webpack_public_path__ + "img/sert3Big.693dcead.png";